import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { ClientUserCreateRequest } from '~client/model/client-user-create-request';
import { ResponseEntity } from '~client/model/response-entity';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

export type CreateClientUserTask = OneArgTask<ClientUserCreateRequest, ResponseEntity>;

/* Creates a new Client */
export const performCreateClientUser = (
  request: ClientUserCreateRequest,
): Observable<ResponseEntity> => apiClient.clientUserController.createUser$(request);

export const createClientUserTaskFactory = (): CreateClientUserTask =>
  rxTask<ClientUserCreateRequest, ResponseEntity>(performCreateClientUser);



// WEBPACK FOOTER //
// ./interactor/client/perform-create-client-user.ts